<template lang="pug">
li.linkedTabsItem
  nuxt-link(
    :to="to"
    :append="append"
    :disabled="disabled"
    :tabindex="disabled ? -1 : 0"
    :exact="exact"
    :class="{ 'nuxt-link-active': isActive}"
  )
    slot
</template>

<script>
export default {
  props: {
    to: { type: String, default: () => '' },
    append: { type: Boolean, default: () => false },
    disabled: { type: Boolean, default: () => false },
    exact: { type: Boolean, default: () => false },
    isActive: { type: Boolean, default: () => false },
  },
}
</script>

<style lang="scss" scoped>
.linkedTabsItem {
  width: 100%;
  display: flex;

  a {
    outline: none;
    background: #4a381c;
    border-radius: 5px 5px 0px 0px;
    color: #ffeece;
    font-weight: bold;
    font-size: 12px;
    padding: 10px;
    text-align: center;
    text-decoration: none;
    transition: all 0.3s;
    width: 100%;
    align-items: center;

    &.nuxt-link-active {
      background: #1d1e21;
      border-bottom: 1px solid #a88c59;
    }

    &[disabled] {
      cursor: default;
      opacity: 0.5;
      pointer-events: none;
    }

    ::v-deep svg {
      margin-right: 0.5rem;
    }
  }
}

@media (min-width: 768px) {
  .linkedTabsItem {
    a {
      font-size: 14px;
    }
  }
}
</style>
